/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { validateEnvironmentVariables } from "./commons/EnvVariables";
// TODO: uncomment to reimplement sentry
// import * as Sentry from "@sentry/react"
// import { Integrations } from "@sentry/tracing"

validateEnvironmentVariables();

// TODO: uncomment to reimplement sentry
// if (process.env.NODE_ENV === "production") {
//     Sentry.init({
//         dsn: "https://36b444cde1f84bb89b67f16310787820@o738116.ingest.sentry.io/6029271",
//         integrations: [new Integrations.BrowserTracing()],
//         environment: process.env.NODE_ENV,
//         release: process.env.REACT_APP_RELEASE,
//         // Set tracesSampleRate to 1.0 to capture 100%
//         // of transactions for performance monitoring.
//         // We recommend adjusting this value in production
//         tracesSampleRate: 1.0,
//     })
// }

ReactDOM.render(<App />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
